<section class="flex items-center justify-center h-screen">
    <div class="w-full max-w-md px-4 py-8 bg-white shadow drop-shadow-lg sm:rounded-lg sm:px-10">
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <div class="flex items-center justify-center w-full mb-6">
                <img src="assets/images/logo.svg" alt="logo" />
            </div>

            <!-- Email Field -->
            <div class="mb-6">
                <label for="email" class="block mb-2 text-sm text-primary"> Email </label>
                <div class="relative">
                    <app-input
                        type="email"
                        id="email"
                        [inputClass]="'input input--primary' + (isFieldInvalid('email') ? ' input--error' : '')"
                        formControlName="email"
                        placeholder="Your Email"
                        [showError]="isFieldInvalid('email')"
                    ></app-input>
                </div>
                @if (getFieldError("email")) {
                    <div class="flex items-center mt-1 text-xs text-red-600">
                        <lucide-icon class="w-4 h-4 mr-2 text-red-500" [img]="CircleAlert"></lucide-icon>
                        {{ getFieldError("email") }}
                    </div>
                }
            </div>

            <!-- Password Field -->
            <div class="mb-6">
                <label for="password" class="block mb-2 text-sm text-primary"> Password </label>
                <div class="relative">
                    <app-input
                        type="password"
                        id="password"
                        [inputClass]="'input input--primary' + (isFieldInvalid('password') ? ' input--error' : '')"
                        formControlName="password"
                        placeholder="Your Password"
                        [showError]="isFieldInvalid('password')"
                    ></app-input>
                </div>
                @if (getFieldError("password")) {
                    <div class="flex items-center mt-1 text-xs text-red-600">
                        <lucide-icon class="w-4 h-4 mr-2 text-red-500" [img]="CircleAlert"></lucide-icon>
                        {{ getFieldError("password") }}
                    </div>
                }
            </div>

            @if (!otpStep) {
                <!-- Forgot Password Link -->
                <div class="flex items-center justify-end mb-6">
                    <a routerLink="/forgot-password" class="text-sm link link--primary"> Forgot Password? </a>
                </div>
            }

            <div class="flex flex-col space-y-4">
                @if (!otpStep) {
                    <!-- Login Button -->
                    <app-button
                        type="submit"
                        class="w-full sm:w-auto"
                        label="Login"
                        loadingText="Logging in..."
                        [isLoading]="isLoading"
                        btnClass="button button--primary transition font-medium rounded-lg text-sm w-full px-5 py-2.5 text-center flex items-center justify-center"
                    ></app-button>

                    <!-- Register Button -->
                    <button
                        type="button"
                        class="transition text-secondary border border-secondary hover:bg-slate-50 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center"
                        (click)="onNavigateToRegister()"
                    >
                        Register
                    </button>
                } @else {
                    <!-- OTP Field -->
                    <div class="mb-6">
                        <label for="otp" class="block mb-2 text-sm text-primary">OTP Code</label>
                        <div class="relative">
                            <app-input
                                type="text"
                                id="otp"
                                [preventCopy]="true"
                                [preventPaste]="true"
                                [preventCut]="true"
                                [inputClass]="'input input--primary' + (isFieldInvalid('otp') ? ' input--error' : '')"
                                [showError]="isFieldInvalid('otp')"
                                formControlName="otp"
                                maxlength="6"
                                placeholder="Enter OTP"
                            ></app-input>
                        </div>
                        @if (getFieldError("otp")) {
                            <div class="flex items-center mt-1 text-xs text-red-600">
                                <lucide-icon class="w-4 h-4 mr-2 text-red-500" [img]="CircleAlert"></lucide-icon>
                                {{ getFieldError("otp") }}
                            </div>
                        }
                        @if (!otpVerified) {
                            <div class="flex items-center justify-between mt-2 text-xs text-secondary">
                                <!-- OTP Label and Timer -->
                                <div class="flex items-center gap-2">
                                    @if (!otpExpired) {
                                        <span class="font-semibold">{{ otpLabel }}</span>
                                        <span class="px-2 py-1 rounded text-secondary bg-secondary-20">{{
                                            getFormattedTimer()
                                        }}</span>
                                    } @else {
                                        <span class="px-2 py-1 text-red-700 bg-red-100 rounded">OTP Expired</span>
                                    }
                                </div>
                                <!-- Resend OTP Button -->
                                <div class="flex items-center">
                                    <button
                                        type="button"
                                        class="text-sm link link--primary"
                                        [disabled]="!otpExpired || isResending"
                                        (click)="onResendOtp()"
                                    >
                                        @if (isResending) {
                                            Resending...
                                        } @else {
                                            Resend OTP
                                        }
                                    </button>
                                </div>
                            </div>
                        } @else {
                            <!-- OTP Verified Message -->
                            <div class="flex items-center justify-center mt-3 text-sm font-semibold text-green-600">
                                OTP Verified Successfully
                                <lucide-icon class="w-5 h-5 ml-1 text-green-500" [img]="CircleCheck"></lucide-icon>
                            </div>
                        }
                    </div>
                    <!-- Verify OTP Button -->
                    <app-button
                        type="button"
                        class="w-full sm:w-auto"
                        label="Verify OTP"
                        [isLoading]="isLoading"
                        [disabled]="isLoading || otpExpired || otpVerified"
                        (click)="onVerifyOtp()"
                        btnClass="button button--primary transition font-medium rounded-lg text-sm w-full px-5 py-2.5 text-center flex items-center justify-center"
                    ></app-button>
                }
            </div>
            <div class="flex items-center justify-center mt-6">
                <a routerLink="/about-us" class="text-sm text-primary hover:underline">About Us</a>
            </div>
        </form>
    </div>
</section>
